// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedImage_container__37pao","image":"FeaturedImage_image__1fd5h"};